import { Economics } from '@benzinga/calendar-manager';
import CalendarService from '../lib/services/CalendarService';

const fetchEconomics = (params = {}, pageSize = 1000): Promise<Economics[]> => {
  const query = {
    ...params,
    pagesize: pageSize,
  };

  const Calendar = new CalendarService();

  return Calendar.getEconomics(query).then(({ data }: { data: { economics: Economics[] } }) => {
    if (data && data.economics) {
      return data.economics;
    }

    return [];
  });
};

export { fetchEconomics };
